import { useEffect } from 'react';

import { clearOrganizationSwitchTarget } from '@app/components/OrganizationSelect/utils/switchTargetStorage';

// Сколько оверлей ждёт новый профиль после перезагрузки, прежде чем сняться
// принудительно. cookie-реавторизация обычно занимает 1–2 c; если она не прошла
// (ветка catch в usePage, редирект на логин), профиль не появится вовсе —
// без этого выхода приложение осталось бы навсегда закрыто непрозрачным
// экраном «Переключаем…».
const RESUME_TIMEOUT_MS = 20000;

interface UseOrganizationSelectEffectsParams {
  // Оверлей поднят после перезагрузки и ждёт новый профиль (переключение
  // начато не в этой сессии страницы).
  isAwaitingProfile: boolean;
  // Профиль вошедшего пользователя уже в сторе.
  hasProfile: boolean;
  // Завершить переключение: снять оверлей.
  onResolve: () => void;
}

export const useOrganizationSelectEffects = ({
  isAwaitingProfile,
  hasProfile,
  onResolve,
}: UseOrganizationSelectEffectsParams) => {
  // Профиль подтянулся — переключение завершено, снимаем оверлей.
  useEffect(() => {
    if (isAwaitingProfile && hasProfile) {
      clearOrganizationSwitchTarget();
      onResolve();
    }
  }, [isAwaitingProfile, hasProfile, onResolve]);

  // Профиль так и не пришёл — запасной выход по таймауту.
  useEffect(() => {
    if (!isAwaitingProfile) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      clearOrganizationSwitchTarget();
      onResolve();
    }, RESUME_TIMEOUT_MS);

    return () => window.clearTimeout(timeoutId);
  }, [isAwaitingProfile, onResolve]);
};
